import React from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

const Tabulation = ({ t, tabs, value, onChange, isLoading, label }) => {
  return (
    <>
      <FormGroup className="select2-container pl-3 w-100">
        <Label className="control-label">{label}</Label>
        <Select
          classNamePrefix="select2-selection"
          placeholder={t("Choose") + "..."}
          options={tabs}
          onChange={onChange}
          value={value}
          isLoading={isLoading}
        />
      </FormGroup>
    </>
  );
};
export default withTranslation()(Tabulation);
